<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="shopsSelected"
    clearable
    :items="shopsItems"
    :loading="shopsLoading"
    :search-input.sync="shopsSearch"
    item-text="Description"
    item-value="id"
    :label="$t('Shop.title')"
    return-object
  ></v-autocomplete>
</template>

<script>
import Shops from "@/api/shops";

export default {
  name: "SearcherShop",

  props: ["value", "districtCodes", "allianceBusinessIds"],

  computed: {
    shopsItems() {
      return this.shops.map((shop) => {
        const Description = shop.shop_code + " / " + shop.shop_name;
        return Object.assign({}, shop, { Description });
      });
    },
  },

  data: () => ({
    shops: [],
    shopsLoading: false,
    shopsSearch: "",
    shopsSelected: null,
  }),

  methods: {
    getShopsFromAPI() {
      this.shopsLoading = true;
      Shops.fetchAllForSelect({
        keyword: this.shopsSearch,
        district_codes: this.districtCodes,
        alliance_business_ids: this.allianceBusinessIds,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.shops = response.data.shops;
            }
            this.shopsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.shopsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.shopsSelected = this.value;
      },
    },
    shopsSelected: {
      handler() {
        this.$emit("input", this.shopsSelected);
      },
    },
    shopsSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (
          this.shopsSelected &&
          this.shopsSearch ==
            this.shopsSelected.shop_code + " / " + this.shopsSelected.shop_name
        )
          return; // 查询结果一致的话不再执行

        this.getShopsFromAPI();
      },
    },
    districtCodes: {
      handler() {
        this.getShopsFromAPI();
      },
    },
    allianceBusinessIds: {
      handler() {
        this.getShopsFromAPI();
      },
    },
  },
};
</script>
